// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Flip Animation Styles */
/* .flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  perspective: 1000px;
}

.flipped {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  padding: 30px;
  top: 0;
  left: 0;
}

.flip-card-front {
  background-color: white;
}

.flip-card-back {
  transform: rotateY(180deg);
  background-color: white;
  padding: 60px;
} */

/* register form container styles */

.form-inner-container {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 60px;
  border-radius: 5px;
}

/* Existing Styles with Updates */
.registerForm__mianWrapper {
  background-image: url("https://res.cloudinary.com/ddpzz4n4i/image/upload/v1739533591/AgentLoginBg_rwf1jp.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100vh;
  padding: 20px 60px;
  font-family: Poppins;
}

.registerForm_Container {
  width: 100%;
  height: 100%;
  display: flex;
  margin: auto;
  gap: 10%;
  border-radius: 8px;
}

.registerForm_firstBox {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  position: relative;
}

.registerForm_firstBbox_heading h1 {
  font-size: 38px;
  font-weight: 500;
  margin-bottom: 10px;
}

.registerForm_firstBbox_heading p {
  font-size: 14px;
  font-weight: 500;
}

.registerForm_wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin-top: 30px;
  box-sizing: border-box;
}

.registerForm_btn {
  background-color: #060642;
  margin-top: 30px;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}

.registerForm_btn_login {
  width: 100%;
  height: 53px;
  margin-top: 20%;
  background-color: #060642;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
}

.registerForm_wrapper .required {
  color: red;
}

.registerForm_wrapper input,
.registerForm_wrapper select {
  border-bottom: 1px solid #84818a;
  width: 100%;
  padding: 5px 0;
  box-sizing: border-box;
  background: transparent;
}

.registerForm_wrapper select:focus {
  outline: none;
}

.registerForm_wrapper label {
  display: block;
  font-size: 14px;
  color: #84818a;
}

.registerForm_wrapper input:focus {
  outline: none;
}

.registerForm_Name_wrapper {
  display: flex;
  width: 100%;
  gap: 30px;
}

.registerForm_name {
  width: 100%;
  flex: 1 1;
}

.registerForm_city {
  display: flex;
  gap: 30px;
}

.registerForm_secondBox {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.registerForm_secondBox_Text {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 20px;
}

.registerForm_secondBox_Text h1 {
  font-size: 70px;
  color: white;
  font-weight: 700;
  line-height: 84.67px;
  font-family: Poppins;
}

.registerForm_secondBox_Text p {
  color: white;
  font-size: 18px;
  font-weight: 400;
  line-height: 30.66px;
}

.registerForm_secondBox_Text ul {
  list-style: disc;
  color: white;
  font-size: 18px;
  list-style-position: inside;
}

.registerForm_logo {
  width: 352px;
  margin-bottom: 20px;
}

/* Flip toggle button styles */
button[type="button"] {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  color: #f78b2b;
}

button[type="button"]:focus {
  outline: none;
}

/* Responsive layouts */

@media (max-width: 767px) {
  .registerForm_secondBox {
    display: none;
  }
  .registerForm__mianWrapper {
    padding: 20px;
  }
  .flip-card-back {
    padding: 30px;
  }
  .registerForm_btn_login {
    margin-top: 400px;
  }

  .registerForm__mianWrapper {
    height: 120vh;
  }
  .registerForm_firstBbox_heading h1 {
    font-size: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Register/SteperFormSection.css"],"names":[],"mappings":"AAEA,0BAA0B;AAC1B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiCG;;AAEH,mCAAmC;;AAEnC;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,8GAA8G;EAC9G,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,gCAAgC;EAChC,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAO;AACT;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,uBAAuB;;AAEvB;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n/* Flip Animation Styles */\n/* .flip-card-inner {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  transition: transform 0.6s;\n  transform-style: preserve-3d;\n  perspective: 1000px;\n}\n\n.flipped {\n  transform: rotateY(180deg);\n}\n\n.flip-card-front,\n.flip-card-back {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  padding: 30px;\n  top: 0;\n  left: 0;\n}\n\n.flip-card-front {\n  background-color: white;\n}\n\n.flip-card-back {\n  transform: rotateY(180deg);\n  background-color: white;\n  padding: 60px;\n} */\n\n/* register form container styles */\n\n.form-inner-container {\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  padding: 60px;\n  border-radius: 5px;\n}\n\n/* Existing Styles with Updates */\n.registerForm__mianWrapper {\n  background-image: url(\"https://res.cloudinary.com/ddpzz4n4i/image/upload/v1739533591/AgentLoginBg_rwf1jp.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 100%;\n  height: 100vh;\n  padding: 20px 60px;\n  font-family: Poppins;\n}\n\n.registerForm_Container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  margin: auto;\n  gap: 10%;\n  border-radius: 8px;\n}\n\n.registerForm_firstBox {\n  width: 100%;\n  height: auto;\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.registerForm_firstBbox_heading h1 {\n  font-size: 38px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.registerForm_firstBbox_heading p {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.registerForm_wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  margin-top: 30px;\n  box-sizing: border-box;\n}\n\n.registerForm_btn {\n  background-color: #060642;\n  margin-top: 30px;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.registerForm_btn_login {\n  width: 100%;\n  height: 53px;\n  margin-top: 20%;\n  background-color: #060642;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.registerForm_wrapper .required {\n  color: red;\n}\n\n.registerForm_wrapper input,\n.registerForm_wrapper select {\n  border-bottom: 1px solid #84818a;\n  width: 100%;\n  padding: 5px 0;\n  box-sizing: border-box;\n  background: transparent;\n}\n\n.registerForm_wrapper select:focus {\n  outline: none;\n}\n\n.registerForm_wrapper label {\n  display: block;\n  font-size: 14px;\n  color: #84818a;\n}\n\n.registerForm_wrapper input:focus {\n  outline: none;\n}\n\n.registerForm_Name_wrapper {\n  display: flex;\n  width: 100%;\n  gap: 30px;\n}\n\n.registerForm_name {\n  width: 100%;\n  flex: 1;\n}\n\n.registerForm_city {\n  display: flex;\n  gap: 30px;\n}\n\n.registerForm_secondBox {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.registerForm_secondBox_Text {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.registerForm_secondBox_Text h1 {\n  font-size: 70px;\n  color: white;\n  font-weight: 700;\n  line-height: 84.67px;\n  font-family: Poppins;\n}\n\n.registerForm_secondBox_Text p {\n  color: white;\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 30.66px;\n}\n\n.registerForm_secondBox_Text ul {\n  list-style: disc;\n  color: white;\n  font-size: 18px;\n  list-style-position: inside;\n}\n\n.registerForm_logo {\n  width: 352px;\n  margin-bottom: 20px;\n}\n\n/* Flip toggle button styles */\nbutton[type=\"button\"] {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  color: #f78b2b;\n}\n\nbutton[type=\"button\"]:focus {\n  outline: none;\n}\n\n/* Responsive layouts */\n\n@media (max-width: 767px) {\n  .registerForm_secondBox {\n    display: none;\n  }\n  .registerForm__mianWrapper {\n    padding: 20px;\n  }\n  .flip-card-back {\n    padding: 30px;\n  }\n  .registerForm_btn_login {\n    margin-top: 400px;\n  }\n\n  .registerForm__mianWrapper {\n    height: 120vh;\n  }\n  .registerForm_firstBbox_heading h1 {\n    font-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
